"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
function capitalizeFirstLetter(string) {
  return string.charAt(0) + string.slice(1);
}
var requireComponent = require.context('./en', true, /\.js$/);
var otherLang = {};
var base = {};
requireComponent.keys().forEach(function (fileName) {
  var a = fileName.lastIndexOf('/');
  fileName = '.' + fileName.slice(a);
  var componetName = capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''));
  var componetConfig = requireComponent(fileName).default;
  if (componetName === 'base') {
    base = componetConfig;
  }
  // 其他文件的 route 合并基础 base文件 的 route 值
  if (componetConfig && componetConfig['route']) {
    base['route'] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base['route']), componetConfig['route']);
  }
  otherLang[componetName] = componetConfig;
});
var Lang = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, base), otherLang);
var _default = exports.default = Lang;